import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ABTestingState } from './AB-testing.state';

export const getABTestingState = createFeatureSelector<ABTestingState>('AB-testing');

export const getIsOptimizelyLoaded = createSelector(getABTestingState, (state: ABTestingState) => {
    return state?.optimizely.optimizelyInitialized;
});

export const getIsListenersLoaded = createSelector(
    getABTestingState,
    (state: ABTestingState) => {
        return state?.optimizely.listenersLoaded;
    },
);

export const getABTestingEnabled = createSelector(
    getABTestingState,
    (state: ABTestingState) => state?.enabled,
);

export const getOpenDownloadAppBanner = createSelector(
    getABTestingState,
    (state: ABTestingState) => state?.optimizely.bannerExperiments.openDownloadAppBanner,
);
